import { combineReducers } from "redux";
import {
  homeReducer,
  homeNotificationReducer,
  headerReducer,
} from "./homeReducer";
import {
  productReducer,
  productFilterListReducer,
  productFilterListitemsReducer,
  getSEODataReducer,SearchCategoryReducer,productSizeReducer,cvdVariantsReducer
} from "./productReducer";
import {
  cartReducer,voucherreducer,
  cartNumberReducer,
  youMayLikeReducer,
  updateCartLatestPricereducer,
  addtocartreducer,forgotpasswordreducer,resetpasswordreducer,
  updatecartandorderstatusreducer
} from "./cartReducer";
import { orderReducer, useraddressreducer } from "./orderReducer";
import authReducer from "./authReducer";
import { myAccountReducer } from "./myAccountReducer";
import siteMapReducer from "./siteMapReducer";
import { cvdReducer } from "./cvdReducer";
// import checkoutReducer from './checkoutReducer';
// import { create_post_Reducer } from './create_post_Reducer';
// import { sndPostReducer } from './sendPostReducer';

const appReducer = combineReducers({
  homeReducer: homeReducer,
  homeNotificationReducer: homeNotificationReducer,
  resetpasswordreducer:resetpasswordreducer,
  cartReducer: cartReducer,
  voucherreducer:voucherreducer,
  SearchCategoryReducer:SearchCategoryReducer,
  updatecartandorderstatusreducer:updatecartandorderstatusreducer,
  forgotpasswordreducer:forgotpasswordreducer,
  productFilterListitemsReducer: productFilterListitemsReducer,
  getSEODataReducer: getSEODataReducer,
  orderReducer: orderReducer,
  authReducer: authReducer,
  productReducer: productReducer,
  productSizeReducer:productSizeReducer,
  cvdVariantsReducer:cvdVariantsReducer,
  cartNumberReducer: cartNumberReducer,
  useraddressreducer: useraddressreducer,
  youMayLikeReducer: youMayLikeReducer,
  updateCartLatestPricereducer: updateCartLatestPricereducer,
  productFilterListReducer: productFilterListReducer,
  addtocartreducer: addtocartreducer,
  headerReducer: headerReducer,
  myAccountReducer: myAccountReducer,
  siteMapReducer: siteMapReducer,
  cvdReducer: cvdReducer,
  // create_post_Reducer: create_post_Reducer as any,
  // sendPostReducer:sndPostReducer as any
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
